.options { display: flex; flex-direction: column; gap: var(--space-2); }
.option { position: relative; overflow: hidden; display: flex; align-items: center; gap: var(--space-2); min-height: 48px;
  padding: var(--space-2) var(--space-3); border-radius: var(--radius-button); background: var(--ground); text-align: left; }
.option:disabled { cursor: default; }
.fill { position: absolute; left: 0; top: 0; bottom: 0; background: color-mix(in srgb, var(--accent) 30%, transparent); z-index: 0; }
.option > * { flex-shrink: 0; }
.option > :not(.fill) { position: relative; z-index: 1; }
.mine { box-shadow: inset 0 0 0 2px var(--accent); }
/* имя целиком при крупном шрифте (HQ-1572 v2): перенос по словам, строка растёт; слово шире места — переносится внутри */
.name { flex: 1; min-width: 0; font-size: var(--fs-subheadline); font-weight: 500; line-height: 1.25; overflow-wrap: break-word; }
.percent { font-size: var(--fs-subheadline); font-weight: 600; font-variant-numeric: tabular-nums; }
.note { margin-top: var(--space-2); font-size: var(--fs-caption); color: var(--content-secondary); }
